/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientDetailResponse
 */
export interface ClientDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    caseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    assignedCounselorId: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClientDetailResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    assignedCounselorShortCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    status: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClientDetailResponse
     */
    tintIndex: number;
    /**
     * 
     * @type {string}
     * @memberof ClientDetailResponse
     */
    fullName?: string | null;
}

/**
 * Check if a given object implements the ClientDetailResponse interface.
 */
export function instanceOfClientDetailResponse(value: object): value is ClientDetailResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('caseNumber' in value) || value['caseNumber'] === undefined) return false;
    if (!('assignedCounselorId' in value) || value['assignedCounselorId'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('assignedCounselorShortCode' in value) || value['assignedCounselorShortCode'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('tintIndex' in value) || value['tintIndex'] === undefined) return false;
    return true;
}

export function ClientDetailResponseFromJSON(json: any): ClientDetailResponse {
    return ClientDetailResponseFromJSONTyped(json, false);
}

export function ClientDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'caseNumber': json['caseNumber'],
        'assignedCounselorId': json['assignedCounselorId'],
        'createdAt': (new Date(json['createdAt'])),
        'assignedCounselorShortCode': json['assignedCounselorShortCode'],
        'status': json['status'],
        'tintIndex': json['tintIndex'],
        'fullName': json['fullName'] == null ? undefined : json['fullName'],
    };
}

export function ClientDetailResponseToJSON(json: any): ClientDetailResponse {
    return ClientDetailResponseToJSONTyped(json, false);
}

export function ClientDetailResponseToJSONTyped(value?: ClientDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'caseNumber': value['caseNumber'],
        'assignedCounselorId': value['assignedCounselorId'],
        'createdAt': value['createdAt'].toISOString(),
        'assignedCounselorShortCode': value['assignedCounselorShortCode'],
        'status': value['status'],
        'tintIndex': value['tintIndex'],
        'fullName': value['fullName'],
    };
}

